import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../../../../../config/axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "../../../../../components/Forms/FormInputText";
import moment from "moment";
import { useTranslation } from "react-i18next";

const BookingCheckinDialog = ({ booking, handleSubmit, handleClose }) => {
  function submit(data, { setSubmitting, setStatus }) {
    setSubmitting(true);
    axios
      .put(`/api/v1/bookings/${booking.id}.json`, {
        booking: {
          checkin_at: data.checkin_at,
        },
      })
      .then(function (response) {
        handleSubmit(response.data);
      })
      .catch(function (error) {
        console.log(error.response.data);
        setSubmitting(false);
      });
  }

  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {t("booking_details.booking_checkin_dialog.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            innerRef={formRef}
            initialValues={{
              ...booking,
              checkin_at: moment().format(moment.HTML5_FMT.DATETIME_LOCAL),
            }}
            onSubmit={submit}
          >
            <Form>
              <p>{t("booking_details.booking_checkin_dialog.paragraph1")}</p>

              <FormInputText
                name="checkin_at"
                label={t(
                  "booking_details.booking_checkin_dialog.checkin.label"
                )}
                type="datetime-local"
                disabled={true}
              />
            </Form>
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button onClick={() => formRef?.current?.handleSubmit()}>
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingCheckinDialog;
